import { categoryMap } from '@api/utils';

export const shouldSuppressFaqs = (
	categoryGuid: string | number | null | undefined,
	sort: string | null | undefined,
) => sort === 'featured' && categoryMap[String(categoryGuid)] === 'WPH';
